module.exports = __webpack_public_path__ + "media/images/app/become-vendor/strongbox-2-5e3b3eb142d4c3183607e01288379be5.webp";